import * as React from 'react';
import { CardEvent, DifficultiesText, Difficulties } from 'src/store/events/types';
import { formatDate } from 'src/utils/dateHelper';
import { FamilyFriendly } from 'src/store/shared/types';

export const renderInfoPrint = (event: CardEvent) => (
  <div className="info">
    <table className="eventInfoTable" style={{ textAlign: 'left' }}>
      <tbody>
        {event.begins && (
          <tr>
            <td>
              <span className="bold">Startzeit: </span>
            </td>
            <td>{formatDate(event.begins, 'HH:mm')} Uhr</td>
          </tr>
        )}
        {event.difficulty !== null && event.difficulty > 0 && (
          <tr>
            <td>
              <span className="bold">Schwierigkeit: </span>
            </td>
            <td>{DifficultiesText[Difficulties[event.difficulty]]}</td>
          </tr>
        )}
        {event.familyfriendly !== null && (
          <tr>
            <td>
              <span className="bold">Familienprogrammpunkt: </span>
            </td>
            <td>
              {event.familyfriendly < 0
                ? FamilyFriendly[event.familyfriendly]
                : `Ja ab ${event.familyfriendly}`}
            </td>
          </tr>
        )}
        {event.meetingpoint && (
          <tr>
            <td>
              <span className="bold">Treffpunkt: </span>
            </td>
            <td>{event.meetingpoint}</td>
          </tr>
        )}
        {event.duration && (
          <tr>
            <td>
              <span className="bold">Dauer: </span>
            </td>

            <td>{event.duration}</td>
          </tr>
        )}
      </tbody>
    </table>
    <div className="shortDesc">
      {event &&
        event.shortDescription.split('\n').map((item: string, key: number) => {
          return (
            <span key={key}>
              {item}
              <br />
            </span>
          );
        })}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/utils/Print/RenderInfoPrint.tsx